import './App.less';
import loadable from './utils/loadable';
const BackgroundOverlay = loadable(() => import('./components/backgroundOverlay'));
const Counters = loadable(() => import('./components/counters'));
const Testimonial = loadable(() => import('./components/testimonial'));
const DesignCard = loadable(() => import('./components/designCard'));


const App = () => {

  return (
    <>

      <BackgroundOverlay />

      <Counters />

      <DesignCard />

      <Testimonial />

    </>
  );
}

export default App;